// extracted by mini-css-extract-plugin
export default {"passDialog":"passDialog--_VKIL","markerAnimationScale":"markerAnimationScale--jcWPl"};